import { environment } from "@env";

interface MetaDataItem {
    title: string;
    description?: string;
    keyword?: string;
    metaTitle: string;
    metaDescription: string;
    image?: string;
}

export class MetaDataConstant {
    public static readonly DEFAULT: MetaDataItem = {
        title: 'iFAST Global Markets一To Help Investors around the World Invest Globally and Profitably | 協助環球投資者慧視全球、投資致富',
        metaTitle: 'iFAST Global Markets | Fintech Powered One-Stop Wealth Management Platform',
        description: 'Discover our platform, where the expertise of seasoned advisors meets innovative fintech solutions, offering you simple and transparent financial planning. Supported by our parent company, iFAST Corporation Ltd. (SGX:AIY), headquartered in Singapore.',
        metaDescription: 'Discover our platform, where the expertise of seasoned advisors meets innovative fintech solutions, offering you simple and transparent financial planning. Supported by our parent company, iFAST Corporation Ltd. (SGX:AIY), headquartered in Singapore.',
        image: `${environment.imagePath}/thumbnail.png`
    };

    public static readonly HOME: MetaDataItem = {
        title: 'thumbnail.home.title',
        description: 'tag.home.page.des',
        keyword: 'tag.home.page.keywords',
        metaTitle: 'thumbnail.home.title',
        metaDescription: 'thumbnail.home.des',
        image: `${environment.imagePath}/thumbnail.png`
    };

    public static readonly HYBRID_MODEL: MetaDataItem = {
        title: 'thumbnail.hybrid.title',
        description: 'tag.hybrid.model.des',
        keyword: 'tag.hybrid.model.keywords',
        metaTitle: 'thumbnail.hybrid.title',
        metaDescription: 'thumbnail.hybrid.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly CIES: MetaDataItem = {
        title: 'thumbnail.cies.title',
        description: 'thumbnail.cies.des',
        keyword: '',
        metaTitle: 'thumbnail.cies.title',
        metaDescription: 'thumbnail.cies.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly GLOBAL_CONNECTION: MetaDataItem = {
        title: 'thumbnail.global.title',
        description: 'tag.global.connection.des',
        keyword: 'tag.global.connection.keywords',
        metaTitle: 'thumbnail.global.title',
        metaDescription: 'thumbnail.global.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly IGM_MOBILE_APP: MetaDataItem = {
        title: 'thumbnail.app.title',
        description: 'tag.igm.mobile.app.des',
        keyword: 'tag.igm.mobile.app.keywords',
        metaTitle: 'thumbnail.app.title',
        metaDescription: 'thumbnail.app.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly TRADING_PLATFORM: MetaDataItem = {
        title: 'thumbnail.trading.title',
        description: 'tag.trading.platform.des',
        keyword: 'tag.trading.platform.keywords',
        metaTitle: 'thumbnail.trading.title',
        metaDescription: 'thumbnail.trading.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly INDIVIDUAL: MetaDataItem = {
        title: 'thumbnail.indi.wrap.title',
        description: 'tag.indi.des',
        keyword: 'tag.indi.keywords',
        metaTitle: 'thumbnail.indi.wrap.title',
        metaDescription: 'thumbnail.indi.wrap.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly SELF_SERVED: MetaDataItem = {
        title: 'thumbnail.self.served.title',
        description: 'tag.self.served.des',
        keyword: 'tag.self.served.keywords',
        metaTitle: 'thumbnail.self.served.title',
        metaDescription: 'thumbnail.self.served.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly CORPORATE: MetaDataItem = {
        title: 'thumbnail.corp.title',
        description: 'tag.corporate.des',
        keyword: 'tag.corporate.keywords',
        metaTitle: 'thumbnail.corp.title',
        metaDescription: 'thumbnail.corp.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly DISCRETIONARY: MetaDataItem = {
        title: 'thumbnail.discretionary.title',
        description: 'tag.discretionary.des',
        keyword: 'tag.discretionary.keywords',
        metaTitle: 'thumbnail.discretionary.title',
        metaDescription: 'thumbnail.discretionary.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly MULTI_CURRENCY_CASH_ACCOUNT: MetaDataItem = {
        title: 'thumbnail.multi.currency.title',
        description: 'tag.multi.currency.cash.acct.des',
        keyword: 'tag.multi.currency.cash.acct.keywords',
        metaTitle: 'thumbnail.multi.currency.title',
        metaDescription: 'thumbnail.multi.currency.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly INTEREST_RATE: MetaDataItem = {
        title: 'thumbnail.interest.rate.title',
        description: 'tag.interest.rate.des',
        keyword: 'tag.interest.rate.keywords',
        metaTitle: 'thumbnail.interest.rate.title',
        metaDescription: 'thumbnail.interest.rate.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly FX: MetaDataItem = {
        title: 'thumbnail.fx.title',
        description: 'tag.fx.des',
        keyword: 'tag.fx.keywords',
        metaTitle: 'thumbnail.fx.title',
        metaDescription: 'thumbnail.fx.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly MAKING_PAYMENT: MetaDataItem = {
        title: 'thumbnail.payment.title',
        description: 'tag.payment.des',
        keyword: 'tag.payment.keywords',
        metaTitle: 'thumbnail.payment.title',
        metaDescription: 'thumbnail.payment.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly AUTO_SWEEP: MetaDataItem = {
        title: 'thumbnail.auto.sweep.title',
        description: 'tag.auto.sweep.des',
        keyword: 'tag.auto.sweep.keywords',
        metaTitle: 'thumbnail.auto.sweep.title',
        metaDescription: 'thumbnail.auto.sweep.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly PRODUCT_FINANCING: MetaDataItem = {
        title: 'thumbnail.product.financing.title',
        description: 'tag.product.financing.des',
        keyword: 'tag.product.financing.keywords',
        metaTitle: 'thumbnail.product.financing.title',
        metaDescription: 'thumbnail.product.financing.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly FUNDS: MetaDataItem = {
        title: 'thumbnail.funds.title',
        description: 'tag.fund.des',
        keyword: 'tag.fund.keywords',
        metaTitle: 'thumbnail.funds.title',
        metaDescription: 'thumbnail.funds.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly BONDS: MetaDataItem = {
        title: 'thumbnail.bonds.title',
        description: 'tag.bonds.des',
        keyword: 'tag.bonds.keywords',
        metaTitle: 'thumbnail.bonds.title',
        metaDescription: 'thumbnail.bonds.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly STOCKS: MetaDataItem = {
        title: 'thumbnail.stocks.title',
        description: 'tag.stocks.des',
        keyword: 'tag.stocks.keywords',
        metaTitle: 'thumbnail.stocks.title',
        metaDescription: 'thumbnail.stocks.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly ETFS: MetaDataItem = {
        title: 'thumbnail.etfs.title',
        description: 'tag.etfs.des',
        keyword: 'tag.etfs.keywords',
        metaTitle: 'thumbnail.etfs.title',
        metaDescription: 'thumbnail.etfs.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly MANAGE_PORTFOLIO: MetaDataItem = {
        title: 'thumbnail.mp.title',
        description: 'tag.dpms.des',
        keyword: 'tag.dpms.keywords',
        metaTitle: 'thumbnail.mp.title',
        metaDescription: 'thumbnail.mp.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly INSURANCE: MetaDataItem = {
        title: 'thumbnail.insurance.title',
        description: 'tag.insurance.des',
        keyword: 'tag.insurance.keywords',
        metaTitle: 'thumbnail.insurance.title',
        metaDescription: 'thumbnail.insurance.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly MEET_THE_TEAM: MetaDataItem = {
        title: 'thumbnail.meet.team.title',
        description: 'tag.advisers.des',
        keyword: 'tag.advisers.keywords',
        metaTitle: 'thumbnail.meet.team.title',
        metaDescription: 'thumbnail.meet.team.des',
        image: `${environment.imagePath}/thumbnail2.png`
    }

    public static readonly JOIN_US: MetaDataItem = {
        title: 'thumbnail.career.title',
        description: 'tag.career.des',
        keyword: 'tag.career.keywords',
        metaTitle: 'thumbnail.career.title',
        metaDescription: 'thumbnail.career.des',
        image: `${environment.imagePath}/thumbnail2.png`
    }

    public static readonly ARTICLES: MetaDataItem = {
        title: 'thumbnail.articles.title',
        description: 'tag.articles.des',
        keyword: 'tag.articles.keywords',
        metaTitle: 'thumbnail.articles.title',
        metaDescription: 'thumbnail.articles.des',
        image: `${environment.imagePath}/thumbnail2.png`
    }

    public static readonly VIDEOS: MetaDataItem = {
        title: 'thumbnail.youtube.title',
        description: 'tag.video.des',
        keyword: 'tag.video.keywords',
        metaTitle: 'thumbnail.youtube.title',
        metaDescription: 'thumbnail.youtube.des',
        image: `${environment.imagePath}/thumbnail2.png`
    }

    public static readonly ABOUT_US: MetaDataItem = {
        title: 'thumbnail.about.us.title',
        description: 'tag.about.igm.des',
        keyword: 'tag.about.igm.keywords',
        metaTitle: 'thumbnail.about.us.title',
        metaDescription: 'thumbnail.about.us.des',
        image: `${environment.imagePath}/thumbnail.png`
    }

    public static readonly CONTACT_US: MetaDataItem = {
        title: 'thumbnail.contact.us.title',
        metaTitle: 'thumbnail.contact.us.title',
        metaDescription: 'thumbnail.contact.us.des',
        image: `${environment.imagePath}/thumbnail2.png`
    }
}